var _defs, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgMail = function SvgMail(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 29,
    viewBox: "0 0 41 29",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-mail"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 29
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mail",
    clipPath: "url(#clip-mail)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_zocial-email",
    d: "M.072,24.423V6.046q0-.032.1-.606l10.816,9.252L.2,25.061a2.7,2.7,0,0,1-.128-.638ZM1.508,4.164a1.375,1.375,0,0,1,.542-.1H31.179a1.807,1.807,0,0,1,.574.1L20.906,13.448,19.47,14.6l-2.84,2.329L13.791,14.6l-1.436-1.149ZM1.54,26.306l10.88-10.433,4.211,3.414,4.211-3.414,10.88,10.433a1.532,1.532,0,0,1-.542.1H2.05a1.445,1.445,0,0,1-.51-.1ZM22.278,14.692,33.062,5.44a1.9,1.9,0,0,1,.1.606V24.423a2.445,2.445,0,0,1-.1.638Z",
    transform: "translate(3.928 -1.068)",
    fill: "#416fd8"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMail, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mail.231b7d7f.svg";
export { ForwardRef as ReactComponent };